export default "__VITE_ASSET__CboaVVxR__"